export default __webpack_public_path__ + "static/media/Crt3.66ea9b45.png";